<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import {MouseEnterTipsViewUtil} from "../Information/MouseEnterTipsViewUtil";

    const dispatcher = createEventDispatcher();

    export let isDisabled = false;
    export let tipsMessage = null;
    export let disableTipsMessage = null;

    onMount(() => {
    });

    function onClick() {
        if (isDisabled) {
            return;
        }

        dispatcher('click', {});
    }

    function onMouseEnter(event) {
        if (isDisabled) {
            if (disableTipsMessage != null) {
                MouseEnterTipsViewUtil.show(event, disableTipsMessage);
            }
        } else {
            if (tipsMessage != null) {
                MouseEnterTipsViewUtil.show(event, tipsMessage);
            }
        }

    }

</script>

<button class="add-button-view" on:click|stopPropagation|preventDefault={onClick}
        class:disabled={isDisabled}
        on:mouseenter={onMouseEnter}
        tabindex={0}
>
    <FontAwesomeView icon="plus"/>
    <span class="label">
        追加
    </span>

</button>
<style lang="scss">
    .add-button-view {

        font-size: 0.75em;


        .label {
            white-space: nowrap;
        }

        &:hover {
            opacity: 0.5;
        }

        &.disabled {
            opacity: 0.2;
            cursor: not-allowed;

            &:hover {

            }
        }
    }
</style>